export enum DnBtnSize {
  EXTRA_LARGE = 'extra-large',
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
  FLEX = 'flex',
}
